import React, { useEffect, useState } from "react";
export function TypingAnimation({ text, duration = 50 }) {
    const [displayedText, setDisplayedText] = useState("");
    const [i, setI] = useState(0);
    useEffect(() => {
        const typingEffect = setInterval(() => {
            if (i < text.length) {
                setDisplayedText(text.substring(0, i + 1));
                setI(i + 1);
            }
            else {
                clearInterval(typingEffect);
            }
        }, duration);
        return () => {
            clearInterval(typingEffect);
        };
    }, [duration, i]);
    return React.createElement(React.Fragment, null, displayedText ? displayedText : text);
}
//# sourceMappingURL=TypingAnimation.js.map